let slides = Array.from(document.querySelectorAll('[data-carousel-slide]'));
let buttons = document.querySelectorAll('[data-carousel-button]');
let carousel = document.querySelector('[data-carousel]');
let dotsContainer = document.getElementById('carousel-dots');
let startX = 0;

function clearSlideAttributes(slide) {
	delete slide.dataset.active;
	delete slide.dataset.prev;
	delete slide.dataset.next;
	delete slide.dataset.outPrev;
	delete slide.dataset.outNext;
}

function updateDots(activeIndex) {
	let dots = dotsContainer.querySelectorAll('button');
	dots.forEach((dot, index) => {
		dot.classList.toggle('active', index === activeIndex);
	});
}

function goToSlide(directionOrIndex) {
	let currentIndex = slides.findIndex((slide) => 'active' in slide.dataset);
	let currentSlide = slides[currentIndex];
	let newIndex;

	if (typeof directionOrIndex === 'number') {
		newIndex = directionOrIndex;
	} else {
		let offset = directionOrIndex === 'next' ? 1 : -1;
		newIndex = (currentIndex + offset + slides.length) % slides.length;
	}

	if (newIndex === currentIndex) return;

	let newSlide = slides[newIndex];
	clearSlideAttributes(currentSlide);
	clearSlideAttributes(newSlide);

	if (typeof directionOrIndex === 'number' || directionOrIndex === 'next') {
		currentSlide.dataset.outNext = true;
		newSlide.dataset.next = true;
	} else {
		currentSlide.dataset.outPrev = true;
		newSlide.dataset.prev = true;
	}

	newSlide.dataset.active = true;
	updateDots(newIndex);

	currentSlide.addEventListener('animationend', function handler() {
		clearSlideAttributes(currentSlide);
		currentSlide.removeEventListener('animationend', handler);
	});
}

buttons.forEach((button) => {
	button.addEventListener('click', () => {
		goToSlide(button.dataset.carouselButton);
	});
});

carousel.addEventListener('touchstart', (e) => {
	startX = e.changedTouches[0].screenX;
});

carousel.addEventListener('touchend', (e) => {
	let endX = e.changedTouches[0].screenX;
	let diff = endX - startX;
	if (Math.abs(diff) > 50) {
		goToSlide(diff > 0 ? 'prev' : 'next');
	}
});

slides.forEach((_, index) => {
	let dot = document.createElement('button');
	if (index === 0) dot.classList.add('active');
	dot.addEventListener('click', () => goToSlide(index));
	dotsContainer.appendChild(dot);
});
